import { useFeatureQuery } from '@common/hooks';
import {
    BaseFeatureArgs,
    InitialQueryState,
    SkipOrArgs,
} from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetAccountsQuery } from '../api';

export interface UseUserAccountsArgs extends BaseFeatureArgs {
    userId: string;
}

export const useUserAccounts = (
    initialArgs: InitialQueryState = {},
    args: SkipOrArgs<UseUserAccountsArgs>,
) => {
    const queryArgs = useMemo(() => {
        if (args === skipToken || !args.userId) return skipToken;

        return args;
    }, [args]);

    return useFeatureQuery(initialArgs, useGetAccountsQuery, queryArgs);
};
